import { call, put, takeLatest } from "redux-saga/effects";
import { userApi } from "../../../api/user/userApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IUserLoadStart, eUserActionTypeIds } from "../../action-types/user/IUserActionTypes";
import { actions } from "../../actions";

export function* userSaga(): any {
    yield takeLatest(eUserActionTypeIds.LOAD_START, loadUserWorker)
}
function* loadUserWorker(action: IUserLoadStart): any {
    const res: IBaseRespone = yield call(userApi.selectAll)
    if (res.is_success) {
        yield put(actions.user.loadUserSuccess(res.data))
    } else {
        yield put(actions.user.loadUserError(res.message))
    }
}